import { FiltersType } from '@/api/types';
import { client } from '@/client';
import {
  ListCourseBranchesResponse,
  ListCourseGroupsResponse,
} from '@/client/courses';
import { COURSES_QUERY_KEY } from '@/hooks/query/courses.query-keys';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

/**
 * @deprecated
 */
export const useCourseBranches = (
  params: UseQueryOptions & {
    take?: number;
    skip?: number;
    sort?: string[];
    filters?: FiltersType;
  },
  courseId?: string,
  accountId?: string,
): UseQueryResult<ListCourseBranchesResponse> & {
  courseBranches: ListCourseBranchesResponse | undefined;
} => {
  const {
    take = 5,
    skip = 0,
    sort,
    filters,
    retry = false,
    retryDelay = 500,
    staleTime = 0,
    cacheTime = 0,
    ...restOptions
  } = params;

  const { data, ...rest } = useQuery(
    [
      `${COURSES_QUERY_KEY}CourseBranches`,
      take,
      skip,
      JSON.stringify(sort),
      JSON.stringify(filters),
    ],
    () => client.courses.getCourseBranches(params, courseId, accountId),
    {
      retry,
      retryDelay,
      staleTime,
      cacheTime,
      ...(restOptions as any),
    },
  );

  return {
    courseBranches: data,
    ...(rest as UseQueryResult<ListCourseBranchesResponse>),
  };
};

/**
 * @deprecated
 */
export const useCourseGroups = (
  params: UseQueryOptions & {
    take?: number;
    skip?: number;
    sort?: string[];
    filters?: FiltersType;
  },
  courseId?: string,
  accountId?: string,
): UseQueryResult<ListCourseGroupsResponse> & {
  courseGroups: ListCourseGroupsResponse | undefined;
} => {
  const {
    take = 5,
    skip = 0,
    sort,
    filters,
    retry = false,
    retryDelay = 500,
    staleTime = 0,
    cacheTime = 0,
    ...restOptions
  } = params;

  const { data, ...rest } = useQuery(
    [
      `${COURSES_QUERY_KEY}CourseGroups`,
      take,
      skip,
      JSON.stringify(sort),
      JSON.stringify(filters),
    ],
    () => client.courses.getCourseGroups(params, courseId, accountId),
    {
      retry,
      retryDelay,
      staleTime,
      cacheTime,
      ...(restOptions as any),
    },
  );

  return {
    courseGroups: data,
    ...(rest as UseQueryResult<ListCourseGroupsResponse>),
  };
};
